/** Preview flags select presentation and freshness only; the server still authorizes the current identity/environment. */
export function getInteractivePreview(search: string) {
  const params = new URLSearchParams(search);
  const enabled = params.get("runtimePreview") === "1";
  const id = params.get("previewApp") ?? "";
  const validId = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id) && !/^0{8}-0{4}-0{4}-0{4}-0{12}$/.test(id);
  return { enabled, appId: enabled && validId ? id : undefined };
}
